import { render, staticRenderFns } from "./DistributorReport.vue?vue&type=template&id=b5da7e92&"
import script from "./DistributorReport.vue?vue&type=script&lang=js&"
export * from "./DistributorReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports